import state from "./moduleGiftcardState"
import getters from "./moduleGiftcardGetters"
import mutations from "./moduleGiftcardMutations"
import actions from "./moduleGiftcardActions"

export default {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};